export const environmentRoot = {
  timeStamp: new Date().toString(),
  popupForLogin: false,
  cacheLocation: 'localStorage',
  instance: 'https://login.microsoftonline.com/',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  clientId: '8e4a98b6-7e79-4d63-81f1-ca836a281566',
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  graphScopes: ['User.Read.All'],
  apiScope: ['api://8e4a98b6-7e79-4d63-81f1-ca836a281566/user_impersonation'],
  accessGroupId: 'Surface-FMO',
  version: '2.0.0',
};
